export const viTri = {
  sections: {
    list: { title: 'Locations' },
    detail: { title: 'Location' },
  },
  titles: { add: 'Add location', edit: 'Edit location', create: 'Create location' },
  columns: {
    chiNhanh: 'Branch',
    code: 'Code',
    summary: 'Location name',
    note: 'Note',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    status: 'Status',
    onOffAction: 'On/Off',
  },
  filter: {
    searchPlaceholder: 'Search by code or name...',
    textDetailTitle: 'Advanced filters',
  },
  filters: {
    hintSection: 'Hint',
    hintBody: 'Storage location catalog used on products.',
    statusAll: 'All',
    chiNhanhAll: 'All branches',
    chiNhanhSearch: 'Search branch',
    chiNhanhEmpty: 'No branches',
  },
  status: {
    dangHoatDong: 'Active',
    ngungHoatDong: 'Inactive',
  },
  actions: {
    pause: 'Deactivate',
    activate: 'Activate',
  },
  messages: {
    loadError: 'Could not load locations.',
    deleteSuccess: 'Location deleted.',
    noData: 'No locations.',
    listSummary: '{count} item(s)',
    saveSuccess: 'Location saved.',
    statusChanged: 'Status updated.',
    createSuccess: 'Location created',
    selectedCount: '{count} selected',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm: 'Delete {count} selected location(s)?',
    bulkDeleteSuccess: 'Deleted {count} location(s)',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} could not be deleted.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No locations selected to delete',
  },
  form: {
    tenViTri: 'Location name',
    tenViTriInline: 'Location',
    maViTri: 'Code (optional)',
    ghiChu: 'Note',
  },
  validation: {
    tenRequired: 'Location name is required.',
  },
  import: {
    description:
      'Excel file has 3 columns: Location code (optional), Location name (required), Note (optional). Empty code will be auto-generated. Existing codes will be updated.',
    success: 'Locations imported from Excel.',
    failed: 'Location import from Excel failed.',
    empty: 'Excel file has no valid data rows.',
  },
  placeholders: {
    formTitle: 'Warehouse location',
    formBody: '',
    tenViTri: 'Enter location name',
  },
}
